import styled from 'styled-components'
import colors from '../../lib/colors'

export const Buttons = styled.div`
  display: flex;
  margin: 6px;
  justify-content: flex-end;
  button {
    display: flex;
    align-items: center;
    transition: 0.2s;
    cursor: pointer;
    width: 100%;
    text-transform: uppercase;
    height: 26px;
    font-family: inherit;
    font-size: 11px;
  }
  > button,
  > div {
    margin-left: 6px;
    &:first-child {
      margin-left: 0;
    }
  }
`

export const BuyButton = styled.button`
  justify-content: center;
  border: none;
  background-color: ${(props): string => props.theme.colourHighlight};
  color: ${(props): string => props.theme.colourTextOnHighlight};
  max-width: 50%;
  font-weight: bold;
  :hover {
    background-color: ${(props): string => props.theme.hover};
  }
  &.active {
    background-color: ${(props): string => props.theme.hover};
  }
  &.sold-out {
    color: ${(props): string => props.theme.colourBodyText};
    background-color: ${colors.white};
    cursor: default;
    :hover {
      background-color: ${colors.white};
    }
  }
  .buy-button-chevron::before {
    border: solid;
    border-width: 0.23em 0.23em 0 0;
    width: 0.3em;
    height: 0.3em;
    margin-bottom: 1px;
    margin-left: 4px;
    content: '';
    display: inline-block;
    transform: rotate(45deg);
  }
  &.select-button-disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`
